<nz-modal
  [(nzVisible)]="visible"
  [nzTitle]="modalTitle"
  [nzFooter]="modalFooter"
  (nzOnCancel)="close()"
  [nzWidth]="700"
>
  <ng-template #modalTitle>
    <app-modal-title icon="history" title="Histórico de Movimientos" />
  </ng-template>

  <div *nzModalContent>
    <nz-spin [nzSpinning]="loading">
      @if (prospect?.sprospecto) {
        <div class="prospect-name">
          <span nz-icon nzType="user" nzTheme="outline"></span>
          {{ prospect!.sprospecto }}
        </div>
      }
      @if (timeline.length > 0) {
        <div class="timeline-scroll">
          <nz-timeline [nzMode]="'left'">
            @for (item of timeline; track item.stageName) {
              <nz-timeline-item [nzColor]="getStageColor(item.stageName, item.status)">
                <nz-card
                  class="movement-card"
                  [style.border-left-color]="getStageColor(item.stageName, item.status)"
                >
                  <!-- Header -->
                  <div class="movement-header">
                    <div class="movement-header__left">
                      <span
                        nz-icon
                        nzType="swap"
                        nzTheme="outline"
                        class="movement-icon"
                        [style.color]="getStageColor(item.stageName, item.status)"
                      ></span>
                      <span class="movement-type">{{ item.stageName }}</span>
                    </div>
                    <nz-tag [nzColor]="getTagColor(item.status)">
                      {{ item.status ?? 'Sin estado' }}
                    </nz-tag>
                  </div>

                  <!-- Body -->
                  <div class="movement-body">
                    <!-- Fecha inicio -->
                    <div class="movement-row">
                      <span nz-icon nzType="clock-circle" nzTheme="outline" class="movement-row__icon"></span>
                      <span>Inicio: {{ formatDate(item.startDate) }}</span>
                    </div>

                    <!-- Fecha fin -->
                    @if (item.endDate) {
                      <div class="movement-row">
                        <span nz-icon nzType="check-circle" nzTheme="outline" class="movement-row__icon"></span>
                        <span>Fin: {{ formatDate(item.endDate) }}</span>
                      </div>
                    }

                    <!-- Comentario de rechazo -->
                    @if (item.cancellationComment) {
                      <div class="movement-row">
                        <span nz-icon nzType="close-circle" nzTheme="outline" class="movement-row__icon" style="color: #ef4444;"></span>
                        <p class="movement-comment">{{ item.cancellationComment }}</p>
                      </div>
                    }

                    <!-- Comentario de reagenda -->
                    @if (item.agendComment) {
                      <div class="movement-row">
                        <span nz-icon nzType="calendar" nzTheme="outline" class="movement-row__icon" style="color: #f59e0b;"></span>
                        <p class="movement-comment">{{ item.agendComment }}</p>
                      </div>
                    }
                  </div>
                </nz-card>
              </nz-timeline-item>
            }
          </nz-timeline>
        </div>
      } @else if (!loading) {
        <div class="empty-state">
          <span nz-icon nzType="history" nzTheme="outline" class="empty-state__icon"></span>
          <p>No hay movimientos registrados para este prospecto.</p>
        </div>
      }
    </nz-spin>
  </div>

  <ng-template #modalFooter>
    <div class="modal-footer">
      <button nz-button class="sinay-outline-reset" (click)="close()">Cerrar</button>
    </div>
  </ng-template>
</nz-modal>
